import { InjectionToken } from '@angular/core';
import type { Subject } from 'rxjs';
import type { FocusableOption } from '@angular/cdk/a11y';

export interface FlyoutMenuItem extends FocusableOption {
  key(): string | undefined;
  disabled: boolean;
  triggersSubmenu(): boolean;
  clickedSubject: Subject<FlyoutMenuItem>;
}

export interface FlyoutMenuHost {
  addItem(item: FlyoutMenuItem): void;
  removeItem(item: FlyoutMenuItem): void;
}

export const FLYOUT_MENU_HOST = new InjectionToken<FlyoutMenuHost>('FlyoutMenuHost');

